<template>
    <CContainer class="section" fluid>
        <CRow class="border-bottom">
            <CCol md="10">
                <h2 class="section__title my-4">{{ $t("user_manager") }}</h2>
            </CCol>
            <CCol md="2">
                <CDropdown
                    color="primary"
                    :toggler-text="$t('actions')"
                    class="m-2"
                >
                    <CDropdownItem
                        tag="div"
                        class="text-cent\er"
                        @click="openModalUpdateUser(forms.user)"
                    >
                        <strong>{{ $t("update_data") }}</strong>
                    </CDropdownItem>
                    <CDropdownItem tag="div" class="text-cent\er"
                        @click="openModalChangePassword(forms.user)"
                    >
                        <strong>{{ $t("change_password") }}</strong>
                    </CDropdownItem>
                </CDropdown>
            </CCol>
        </CRow>
        <CRow alignVertical="center" alignHorizontal="center">
            <CCol sm="12">
                <h3 class="mt-3">{{ $t("user_data") }}</h3>
            </CCol>
            <CCol md="10" sm="12">
                <CForm ref="formUser" :disabled="true">
                    <CInput
                        :value.sync="forms.user.email"
                        :label="$t('email')"
                        :disabled="true"
                    />
                    <CInput
                        :value.sync="forms.user.name"
                        :label="$t('first_name')"
                        :disabled="true"
                    />
                    <CInput
                        :value.sync="forms.user['custom:last_name']"
                        :label="$t('last_name')"
                        :disabled="true"
                    />
                    <CInput
                        :value.sync="forms.user.phone_number"
                        :label="$t('phone')"
                        :disabled="true"
                    />

                    <CInput
                        :value.sync="forms.user['custom:postal_code']"
                        :label="$t('postal_code')"
                        :disabled="true"
                    />

                    <CInput
                        :value.sync="forms.user['custom:city']"
                        :label="$t('city')"
                        :disabled="true"
                    />

                    <CInput
                        :value.sync="forms.user['custom:company']"
                        :label="$t('company')"
                        :disabled="true"
                    />

                    <SelectCountry
                        :label="$t('country')"
                        :placeholder="$t('select_an_country')"
                        :value.sync="forms.user['custom:country_id']"
                    />

                    <SelectLanguage
                        :value.sync="forms.user['custom:language_id']"
                        :label="$t('language')"
                        :placeholder="$t('select_an_country')"
                    />
                </CForm>
            </CCol>
        </CRow>
        <UpdateUserModal
            v-bind="modals.updateUser"
            :show.sync="modals.updateUser.show"
            :user="modals.updateUser.data"
            v-on:submit="afterUpdateUser"
        />
        <ChangeUserPasswordModal 
            v-bind="modals.changePassword"
            :show.sync="modals.changePassword.show"
            v-on:submit="afterChangeUserPassword"
        />
    </CContainer>
</template>
<script>
import { cilPencil, cilCaretBottom, cilCaretTop, cilSave } from "@coreui/icons";
import traslateMixin from "@/mixins/traslate.js";
import formMixin from "@/mixins/form.js";

import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import UpdateUserModal from "~/pages/user/components/UpdateUserModal.vue";
import ChangeUserPasswordModal from "~/pages/user/components/ChangeUserPasswordModal.vue";

export default {
    name: "UserAccountManagerTab",
    mixins: [traslateMixin, formMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
    },
    components: {
        SelectCountry,
        SelectLanguage,
        UpdateUserModal,
        ChangeUserPasswordModal
    },
    data() {
        return {
            forms: {
                user: {
                    name: null,
                    phone_number: null,
                    email: null,
                    "custom:last_name": null,
                    "custom:language_id": null,
                    "custom:country_id": null,
                    "custom:postal_code": null,
                    "custom:city": null,
                    "custom:company": null,
                    _matchResponse: "_items",
                },
            },
            modals: {
                changePassword: {
                    show: false,
                    color: "primary",
                    title: "Change Password",
                    data: {
                    },
                },
                updateUser: {
                    show: false,
                    color: "primary",
                    title: "Update User",
                    closeOnBackdrop: false,
                    data: {},
                },
            },
        };
    },
    methods: {
        openModalUpdateUser(user) {
            this.modals.updateUser.data = user;
            this.modals.updateUser.show = true;
        },
        openModalChangePassword() {
            this.modals.changePassword.data = this.forms.user;
            this.modals.changePassword.show = true;
        },

        async afterUpdateUser(response) {
            this.modals.updateUser.show = false;
            await this.loadFormUser();
            this.$store.dispatch("auth/setLanguageUser", { user: this.forms.user });
        },

        afterChangeUserPassword(response) {
            this.modals.changePassword.show = false;
        },

        async loadFormUser() {
            await this.updateForm({
                formName: "user",
                url: "/account.api/user",
            });
        },
    },
    async mounted() {
        await this.loadFormUser();
    },
};
</script>

<style>
</style>